import { configWithTokenId, configNoHeaders } from '@api/constructor-api'

const promotionListHandler = async (branchUUID) => {
    return await configWithTokenId(async (API) => {
        if(branchUUID != null && branchUUID != 'null')
            return await API.get(`branches/${branchUUID}/promotions`);
        throw 'Not Empty Data'
    })
}

const redeemPromotionHandler = async (payload) => {
    return await configWithTokenId(async (API) => {
        return await API.post('point/redeem', payload)
    })
}

const earnPointsAddFriendHandler = async (payload) => {
    return await configWithTokenId(async (API) => {
        return await API.post('point/earn/add-friend-line', payload)
    })
}

const promotionDetailHandler = async (promotionRefkey) => {
    return await configNoHeaders(async (API) => {
        return await API.get(`promotions/${promotionRefkey}`);
    })
}

export {
    promotionListHandler,
    redeemPromotionHandler,
    promotionDetailHandler,
    earnPointsAddFriendHandler
}